export enum UserGroup {
    FROM_FILE = "0",
}

export enum UpdateKeyListUsers {
    INITIALS = "INITIALS",
    EMAIL = "EMAIL",
    EMPLOYEE_NUMBER = "EMPLOYEE_NUMBER",
}

export type UserGroups = Readonly<{
    id: number
    name: string
    domains: Domain[]
    isActive: boolean
}>

type Domain = Readonly<{
    id: number
    domain: string
}>

export type ImportUsersFormValues = Readonly<{
    userGroupId: string
    updateKey: UpdateKeyListUsers
    updateMatching: boolean
    deleteUnmatched: boolean
    file: null | Blob
}>
